// extracted by mini-css-extract-plugin
export default {"dashboardGrid":"UniversalMFADashboard_dashboardGrid__6Vqms"};